import type { DeliveredListResponse } from '@shared/schemas';

/**
 * Redux state for the client Discovered LPs index; a read-only listing of the
 * lists Invyo delivered to the caller's licence (#712). `error` holds a human-readable
 * message when the load fails (surfaced by the page); the old `useApi` version
 * silently swallowed it. Every field is serialisable.
 */
export interface DiscoveredLpsState {
  rows: DeliveredListResponse[];
  loading: boolean;
  error: string | null;
}

export const initialState: DiscoveredLpsState = {
  rows: [],
  loading: false,
  error: null,
};
